import React, { useEffect } from 'react';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { clearGlobalPopUpWrapper } from '../actions';
import { POPUP_LIST_NAME } from '../../../configs';
import Grid from '../../../components/base/Grid/Grid';
import { dateTimeFormatter, vehicleRegisterStatusFormatter } from '../../../utils/formatters';
import { getVehicleRegistryData } from '../../VehicleRegistry/reducer';
import { loadVehicleRegistryById } from '../../VehicleRegistry/actions';
import { responseLogWithNotification } from '../../../utils/utils';
import DateTimePicker from '../../../components/fields/DatePicker/DateTimePicker';
import TimerLoader from '../../../components/base/Loader/TimerLoader';

export default function VehicleRegistryStatusHistoryPopup({ id }) {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const columns = [
    {
      dataField: 'date',
      text: 'Дата и время',
      headerClassName: 'start-date-column',
      formatter: dateTimeFormatter,
    },
    {
      dataField: 'lpn',
      headerClassName: 'vehicle-reg-number-column',
      text: 'Статус',
      formatter: a => vehicleRegisterStatusFormatter(a),
    },
  ];
  const {
    vehicleRegistryStatusHistory = [],
    loadingVehicleRegistryStatusHistory,
  } = useSelector(getVehicleRegistryData);

  useEffect(() => {
    dispatch(loadVehicleRegistryById(id)).catch(responseLogWithNotification);
  }, [id]);

  return (
    <div className={classNames('full-view custom-scroll-theme vehicle-registry-status-history')}>
      <TimerLoader global loading={loadingVehicleRegistryStatusHistory} />
      <div className="full-view-header">
        <div>Просмотр история статусов</div>
        <Icons onClick={() => dispatch((clearGlobalPopUpWrapper({ key: POPUP_LIST_NAME.VEHICLE_REGISTRY_STATUS_HISTORY_POP_UP })))} customIcon icon="close" />
      </div>
      <div className="full-view-content">
        <div className="view-content-wrapper">
          <div className="d-flex justify-content-end w-100">
            <DateTimePicker
              variant="material"
              onChangeToIso
              placeholder="Дата и время"
            />
          </div>
          <div className="history-table-wrapper mt-3">
            <Grid
              data={vehicleRegistryStatusHistory}
              columns={columns}
              name="application-list"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
